module.exports = __webpack_public_path__ + "img/09.9988e6b0.svg";